module.exports = __webpack_public_path__ + "img/inactive-27.4ab82682.svg";